<template>
    <div class="LanguageView divide-y divide-gray-400 dark:divide-default">
        <CAchievementBox
            v-for="(item, index) in items"
            :key="index"
            class="py-5"
            :class="{ 'pt-0': index === 0, 'pb-0': index === items.length - 1 }"
        >
            <template #icon>
                <CIcon name="language" />
            </template>

            <template #title>
                {{ getNameFromCode(item.code) }}
            </template>

            <template #subtitle>
                {{ getLanguageLevelLabel(item.level) }}
            </template>
        </CAchievementBox>
    </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import type { Language } from '#shared/types/Language'
import { getLanguageNameFromCode } from '#shared/utils/language'

interface Props {
    lang?: 'sk' | 'en'
    items?: Language[]
}

const props = withDefaults(defineProps<Props>(), {
    lang: 'sk',
    items: () => []
})

const { t: $t, t } = useI18n()

const getNameFromCode = (code?: Language['code']) => {
    if (!code) return '-'
    return getLanguageNameFromCode(code, props.lang)
}

function getLanguageLevelLabel(level: string): string {
    const labels = {
        A1: 'Začiatočník (A1)',
        A2: 'Pokročilý začiatočník (A2)',
        B1: 'Stredne pokročilý (B1)',
        B2: 'Vyššie stredne pokročilý (B2)',
        C1: 'Pokročilý (C1)',
        C2: 'Materinský jazyk / Plynulý (C2)'
    }
    return labels[level as keyof typeof labels] || level
}

</script>
